/**备注：--liuxis
 * 1903版取消title参数，直接显示内容，为了避免业务组大规模改动的不稳定因素，把原先的title迁移到content部分,并且取消默认标题title的值
 * 1903弱提示:显示5秒，从显示开始的第4秒开始，2秒淡出淡出
 * 普通提示：帮助(蓝)、预警(黄)、成功(绿)提示3000ms后自动隐藏，错误(红)需要手动隐藏；错误(红)提示5000ms后向右滑出，并且最小化；
 */

//const dangerDuration = 5; //错误(红)提示5000ms后向右滑出，并且最小化
let dangerDuration = 3; //孟伟强、杨立志协商后改成30s  2004发版之前需要改回3s

import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { getMultiLang } from '../getMultiLang';
import { isFunction } from '../utils';
import { getSysFieldid } from '../getSysFieldid';
import { getGlobalStorage } from '../storage';
import { default as NCDnd } from '../../base/Dnd/index';
import { openTo } from '../pageTo';

require('./ToastModal.less');

export default class ToastModal extends Component {
    static defaultProps = {
        duration: 2, //经产品经理(李聪慧)和刘源确认:color为warning/info时，允许业务自定义气泡消失时间
        color: 'success',
        groupOperation: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            whetherShowGroupMsg: false,
            isSlideOut: false, //要移除的时候的标识，添加类去加动画向右滑出
            isMinimize: false, //最小化的标识，5秒后宽度向右缩小最小化,
            // isCustom: false,//是否自定义最小化，失败时，推荐和定位需要
            json: {}, //多语
            isFillFLag: false, // 动画层标识
            fillStyle: {}, // 动画时间
            mouseenterFlag: false, // 鼠标进入离开状态标识
            currentFieldNum: 1,
            showContentTip: false,
            suggestDropShow: true,
            groupShow: true,
            moveY: 0,
            position: {
                x: 0,
                y: 0,
            },
        };
        this.changeSurfaceTimer = null;
        this.slideOutTimer = null;
        this.toMinimizeTimer = null;
        this.toMaximizeTimer = null;
        this.ncc_automated_switch = getGlobalStorage('localStorage', '_ncc_automated_');
        this.isInsideTab = getGlobalStorage('localStorage', 'INSIDE_TAB');
        this.fillDuration = 0;
        this.allFields = [];
        this.allArea = [];
        this.toastMoved = false;
    }

    UNSAFE_componentWillMount() {
        let { color, showGroupOperationMsg } = this.props;
        if (color === 'danger' || showGroupOperationMsg) {
            //只有danger在展示群组操作信息时时默认展开的
            //加了个参数，可以让业务配置showgroupOperationMsg让非danger也展开显示
            this.setState({ whetherShowGroupMsg: true });
        }
        //请求多语
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => {
                    //  在这里进行之前组件willMount的操作，比如加载缓存之类的
                });
            }
        };
        getMultiLang({ moduleId: 'container_toast', callback });
    }

    componentDidMount() {
        let {
            mark,
            light = false,
            containerWindow,
        } = this.props;
        let { toastModalLt, toastModal } = containerWindow || window;
        if (light) {
            this.mark = mark;
            toastModalLt.push(this);
        } else {
            this.mark = mark;
            toastModal.push(this);
        }
        this.showTimer = setTimeout(() => {
            this.resetToastPosition();
        });

        if (mark) {
            this.haveSomeMarkExist(mark);
        }

        // 绑定快捷键事件  bbqin
        document.addEventListener('keyup', this.KeyboardEvent);
        this.toast.querySelector('.toast-fill-mask-shape')?.addEventListener('animationend', this.toastFillAnimationEndHandler);
        this.toastWrapper?.addEventListener('animationend', this.toastAnimationEndHandler);
        // 自动化测试不需要快捷键和鼠标进入离开事件
        if (this.ncc_automated_switch !== '1') {
            this.toast.addEventListener('mouseenter', this.MouseenterEvent);
            this.toast.addEventListener('mouseleave', this.MouseenterLeave);
        }
    }

    // 填充动画结束关闭toast
    toastFillAnimationEndHandler = () => {
        let {
            color,
            light = false,
        } = this.props;
        color !== 'danger' && this.toast.querySelector('.toast-fill-mask-shape')?.removeEventListener('animationend', this.toastFillAnimationEndHandler);
        // 非自动化测试 错误类型最小化，其他类型删除
        // 自动化测试 错误类型保留，其他类型删除
        if (this.ncc_automated_switch !== '1') {
            if (!light && color === 'danger') {
                this.toMinimize();
            } else {
                this.closeToast();
            }
        } else {
            if (!light && color === 'danger') {
                // 自动化测试不关闭错误弹窗
            } else {
                this.closeToast();
            }
        }
    }

    // toast动画结束删除toast
    toastAnimationEndHandler = event => {
        let { target, currentTarget } = event;
        if (target === currentTarget) {
            let element = ReactDOM.findDOMNode(this);
            let parentElement = element.parentNode;
            ReactDOM.unmountComponentAtNode(parentElement);
            parentElement && parentElement.parentNode && parentElement.parentNode.removeChild(parentElement);
            this.resetToastPosition();
        }
    }

    // 绑定快捷键事件  bbqin
    componentWillUnmount() {
        document.removeEventListener('keyup', this.KeyboardEvent);
        this.toast.querySelector('.toast-fill-mask-shape')?.removeEventListener('animationend', this.toastFillAnimationEndHandler);
        this.toastWrapper?.removeEventListener('animationend', this.toastAnimationEndHandler);
        if (this.ncc_automated_switch !== '1') {
            this.toast.removeEventListener('mouseenter', this.MouseenterEvent);
            this.toast.removeEventListener('mouseleave', this.MouseenterLeave);
        }
        this.changeSurfaceTimer && clearTimeout(this.changeSurfaceTimer);
        this.slideOutTimer && clearTimeout(this.slideOutTimer);
        this.toMinimizeTimer && clearTimeout(this.toMinimizeTimer);
        this.toMaximizeTimer && clearTimeout(this.toMaximizeTimer);
        this.changeSurfaceTimer = null;
        this.toMinimizeTimer = null;
        this.toMaximizeTimer = null;
    }

    //鼠标移入提示框 或者 鼠标悬停在提示框上，提示框在从最小化变为最大化 或者保持最大化的状态
    MouseenterEvent = () => {
        //如果是定位，一开始有倒计时动画，鼠标移入，停止动画，鼠标移出继续动画
        let { contentMeta, content, groupOperationMsg } = this.props;
        let { isMinimize } = this.state;
        let toastType = Array.isArray(contentMeta) && this.getToastType(contentMeta);
        if (isMinimize) {
            if (toastType === "locationed") { return; }
            this.setState({ isMinimize: false, mouseenterFlag: true, groupShow: true }, () => {
                this.toastWrapper.querySelector('.toast-fill-mask-shape')?.classList.add('toast-fill-mask-animation');
                this.toMaximizeTimer = setTimeout(() => {
                    this.resetToastPosition();
                }, 100);
            });
        } else {
            if (toastType === "locationed" || groupOperationMsg) {
                this.setState({ isMinimize: false, mouseenterFlag: true }, () => {
                    this.toMaximizeTimer = setTimeout(() => {
                        this.resetToastPosition();
                    }, 100);
                });
            } else {
                this.setState({ mouseenterFlag: true });
            }
        }
    }

    //鼠标从提示框移开 倒计时5s后最小化
    MouseenterLeave = () => {
        let { contentMeta, content, groupOperationMsg } = this.props;
        let { isMinimize, groupShow } = this.state;
        this.setState({ mouseenterFlag: false });//控制进度是暂停还是继续，false则继续，为true则暂停

        let toastType = Array.isArray(contentMeta) && this.getToastType(contentMeta);
        if (toastType === "locationed") {
            if (!isMinimize) {
                this.toastWrapper.querySelector('.toast-fill-mask-shape')?.classList.add('toast-fill-mask-animation');
            }
        } else if (groupOperationMsg) {
            if (groupShow) {
                this.toastWrapper.querySelector('.toast-fill-mask-shape')?.classList.add('toast-fill-mask-animation');
            }
        }
    }

    // 绑定快捷键事件-esc关闭提示框  space最小化danger错误提示  bbqin
    KeyboardEvent = ev => {
        if (ev.keyCode === 27) {
            this.closeToast();
        }
        //张寒回复：UE没有输出过空格键最小化错误类型的需求，要求屏蔽掉， 录入过程中也会输入空格 相互冲突NCC-138265
        // else if (ev.keyCode === 32) {
        //     this.toMinimize(true);
        // }
    };

    //计算toast排列的位置 
    resetToastPosition = () => {
        let { light, containerWindow } = this.props;
        let { toastModalLt, toastModal } = containerWindow || window;
        let toastModalArr = [];
        if (window === window.parent) {
            toastModalArr = toastModal;
        } else {
            toastModalArr = window.parent?.toastModal?.length > 0 && window.parent?.toastModal[0].toastWrapper ? [...toastModal, ...window.parent?.toastModal] : toastModal;
        }

        let ttttoast,
            top,
            spaceBettween;
        if (light) {
            ttttoast = toastModalLt.map(el => {
                if (el && ReactDOM?.findDOMNode(el)) {
                    return ReactDOM?.findDOMNode(el)?.firstElementChild;
                }
            });
            top = 65;
            spaceBettween = 5;
        } else {
            ttttoast = toastModalArr.map(el => {
                return el.toastWrapper?.firstElementChild;
            });
            if (Array.isArray(toastModalArr) && toastModalArr[toastModalArr.length - 1]?.toast?.classList.contains('systemnotifi')) {
                top = this.props.top || (this.isInsideTab === 'true' ? 148 : 120);
            } else {
                top = this.props.top || 80;
            }
            spaceBettween = 10;
        }

        if (ttttoast) {
            let toastArr = Array.from(ttttoast).reverse().filter(i => i);
            let mutativeHArr = [];
            let arr = [];
            toastArr.forEach(el => {
                let mutativeHeight = el?.firstElementChild.offsetHeight;
                mutativeHArr.push(mutativeHeight);
                let h = mutativeHArr.reduce((a, b) => {
                    return a + b;
                }, 0);
                arr.push(h);
            });
            toastArr.forEach((el, i) => {
                el.firstElementChild.style.zIndex = 100001 + i;
                if (i === 0) {
                    // console.log(toastArr[i].firstElementChild.classList.contains('systemnotifi'))
                    toastArr[i].firstElementChild.style.top = top + 'px';
                    toastArr[i].firstElementChild.style.transition = '0.2s';
                } else {
                    if ((toastArr[0].firstElementChild.classList.contains('systemnotifi') || toastArr[0].firstElementChild.classList.contains('warning')) && !toastArr[i].firstElementChild.classList.contains('warning') && i === toastArr.length - 1) {
                        toastArr[i].firstElementChild.style.top = arr[i - 1] + spaceBettween * i + 80 + 'px';
                    } else {
                        toastArr[i].firstElementChild.style.top = arr[i - 1] + spaceBettween * i + top + 'px';
                    }
                    toastArr[i].firstElementChild.style.transition = '0.2s';
                }
            });
        }
    };

    //danger类型的提示最小化
    toMinimize = () => {
        let { color, contentMeta, content, groupOperationMsg } = this.props;
        if (color !== 'danger') { return; }
        // let toastType = Array.isArray(contentMeta) && this.getToastType(contentMeta)
        this.setState({ isMinimize: true, groupShow: false }, () => {
            this.toMinimizeTimer = setTimeout(() => {
                this.resetToastPosition();
            }, 100);
            this.toast.querySelector('.toast-fill-mask-shape')?.classList.toggle('toast-fill-mask-animation');
            if (this.toastMoved) {
                this.setState({ position: { x: 0, y: this.state.moveY } });
                this.toast.style.setProperty('right', '1px');
            }
        });
    }

    //删除toast弹框
    closeToast = () => {
        let { light, containerWindow } = this.props;
        let { toastModalLt, toastModal } = containerWindow || window;
        let index;
        // alltoasts;
        if (light) {
            index = toastModalLt.findIndex(el => el === this);
            index > -1 && toastModalLt.splice(index, 1);
        } else {
            index = toastModal.findIndex(el => el === this);
            index > -1 && toastModal.splice(index, 1);
        }
        if (index !== -1) {
            this.setState({ isSlideOut: true }, () => {
                // this.slideOutTimer = setTimeout(() => {
                //     let element = ReactDOM.findDOMNode(this);
                //     ReactDOM.unmountComponentAtNode(element);
                //     let parentElement = element.parentNode;
                //     parentElement && parentElement.parentNode && parentElement.parentNode.removeChild(parentElement);
                //     this.resetToastPosition();
                // }, 200);
            });
        }
    };

    //切换多条内容显示的展开收起
    ToShowGroupOperationMsg = () => {
        let { whetherShowGroupMsg } = this.state;
        this.setState({ whetherShowGroupMsg: !whetherShowGroupMsg });
        this.changeSurfaceTimer = setTimeout(() => {
            this.resetToastPosition();
        }, 100);
    };

    //同样一个toast提示多次调用只显示一个的支持 mark为String类型，是唯一标识
    haveSomeMarkExist = mark => {
        let { containerWindow } = this.props;
        let { toastModal } = containerWindow || window;
        if (mark && toastModal.length > 1) {
            let ele = null;
            toastModal.forEach((val, i) => {
                toastModal.forEach((el, j) => {
                    if (i !== j) {
                        if (val.mark && el.mark && val.mark === el.mark) {
                            if (i > j) { //i最新的  
                                toastModal.splice(j, 1);
                                ele = el;
                            } else if (i < j) { //j最新的
                                toastModal.splice(i, 1);
                                ele = val;
                            }
                        }
                    }
                });
            });
            if (ele) {
                let element = ReactDOM.findDOMNode(ele);
                let parentElement = element.parentNode;
                ReactDOM.unmountComponentAtNode(parentElement);
                parentElement && parentElement.parentNode && parentElement.parentNode.removeChild(parentElement);

            }
            this.resetToastPosition();
        }
    };

    escapeRegExp = string => {
        return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    }
    replaceAll = (str, find, replace) => {
        return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
    }
    // 推荐下拉切换
    toggleDrop = () => {
        let { suggestDropShow } = this.state;
        this.setState({ suggestDropShow: !suggestDropShow });
    }

    miniToast = () => {
        let { groupShow } = this.state;
        let { content, groupOperationMsg } = this.props;
        if (groupOperationMsg) {
            this.setState({ groupShow: !groupShow });
        } else {
            this.toMinimize();
        }
    }

    maxToast = () => {
        let { groupOperationMsg } = this.props;
        if (groupOperationMsg) {
            this.setState({ groupShow: true, isMinimize: false });
        } else {
            this.setState({ isMinimize: false });
        }
    }

    //所有字段
    getFieldsNum = contentMeta => {
        let fieldsArr = [];
        let allArea = [];
        contentMeta.forEach(item => {
            let { fields, area } = item;
            for (let fieldKey in fields) {
                fieldsArr.push(fields[fieldKey]);
                fields[fieldKey].area = area;
                fields[fieldKey].fieldKey = fieldKey;
            }
            allArea.push(item);
        });
        this.allFields = fieldsArr;
        this.allArea = allArea;
    }
    // 上一个
    preField = props => {
        this.setState({ currentFieldNum: this.state.currentFieldNum === 1 ? this.allFields.length : this.state.currentFieldNum - 1 }, () => {
            // console.log(this.state.currentFieldNum)
            if (this.state.currentFieldNum === 1) {
                this.getCurrentField(this.allFields[0].display, this.allFields[0].area, props);
            } else if (this.state.currentFieldNum === this.allFields.length) {
                this.getCurrentField(this.allFields[this.allFields.length - 1].display, this.allFields[this.allFields.length - 1].area, props);
            } else {
                this.getCurrentField(this.allFields[this.state.currentFieldNum - 1].display, this.allFields[this.state.currentFieldNum - 1].area, props);
            }
        });
    }
    // 下一个   
    nextField = props => {
        this.setState({ currentFieldNum: this.state.currentFieldNum === this.allFields.length ? 1 : this.state.currentFieldNum + 1 }, () => {
            // console.log(this.state.currentFieldNum)
            if (this.state.currentFieldNum === this.allFields.length) {
                this.getCurrentField(this.allFields[this.state.currentFieldNum - 1].display, this.allFields[this.state.currentFieldNum - 1].area, props);
            } else if (this.state.currentFieldNum === 1) {
                this.getCurrentField(this.allFields[this.state.currentFieldNum - 1].display, this.allFields[this.state.currentFieldNum - 1].area, props);
            } else {
                this.getCurrentField(this.allFields[this.state.currentFieldNum - 1].display, this.allFields[this.state.currentFieldNum - 1].area, props);
            }
        });
    }
    // 为field添加区域
    addAreaToField = contentMeta => {
        if (contentMeta[0]?.suggest) {
            contentMeta[0]?.suggest?.forEach((item, index) => {
                item.area = 'filedArea' + index;
            });
        } else {
            contentMeta.forEach((item, index) => {
                item.area = 'filedArea' + index;
            });
        }
        // console.log(contentMeta)
        return contentMeta;
    }
    getCurrentField = (name, area, props) => {
        // console.log(this.allArea)
        let fieldKey, fieldArea;
        this.allArea.forEach(item => {
            let { fields } = item;
            if (fields) {
                for (let k in fields) {
                    if (fields[k].display === name && fields[k].area === area) {
                        fieldKey = k;
                        fieldArea = area;
                    }
                }
            }
        });
        this.focusField(fieldKey, fieldArea, props);
    }
    // 定位字段 最小化时，点击定位
    focusField = (key, area, props) => {
        // console.log(key, area, this.allFields, this.allArea)
        this.allFields?.forEach((item, index) => {
            if (item.fieldKey === key && item.area === area) {
                this.setState({ currentFieldNum: index + 1 });
            }
        });
        let { contentMeta } = this.props;
        if (!contentMeta) { return; }
        let content = Array.isArray(contentMeta) && contentMeta[0].suggest ? contentMeta[0].suggest : contentMeta;
        // console.log(content)
        content.forEach(item => {
            if (item.area === area) {
                let { fields } = item;
                let { params, action, sysParams = {} } = fields[key];
                if (action === 'pageTo') {
                    openTo(null, { ...params }, {}, { ...sysParams });
                } else if (action === 'locationed') {
                    // let { areacode, attrcode, appcode, pagecode, rowIndex, rowKey, colKey, groupAreacode } = params;
                    let areaType = props.getComponentName(params?.areacode);

                    if (params?.callback) {
                        params.callback({ moduleId: params.areacode, attrcode: params.attrcode, rowKey: params?.rowKey });
                    } else if (params?.rowIndex === 0 || params?.rowIndex) {
                        if (areaType === 'editTable') {
                            props?.editTable?.focusRowByIndex(params?.areacode, params?.rowIndex);
                        } else {
                            props?.cardTable?.setTabsTableActive(params?.areacode, params?.areacode);
                            props?.cardTable?.focusRowByIndex(params?.areacode, params?.rowIndex);
                        }
                    } else {
                        if (areaType === 'form') {
                            params?.groupAreacode && props?.form.openArea(params?.areacode, params?.groupAreacode);
                            params?.groupAreacode && document.getElementsByName[params?.groupAreacode]?.scrollIntoView();
                            props?.form?.setFormItemFocus(params?.areacode, params?.attrcode);
                            // props?.form?.setFormItemAutoFocus(params?.areacode, params?.attrcode);
                        } else {
                            if (areaType === 'editTable') {
                                props?.editTable?.setActiveCell(params?.areacode, '', '');
                                props?.editTable?.focusOnCell(params?.areacode, params?.rowKey, params?.colKey);
                            } else {
                                props?.cardTable?.setActiveCell(params?.areacode, '', '');
                                props?.cardTable?.setTabsTableActive(params?.areacode, params?.areacode);
                                setTimeout(() => {
                                    props?.cardTable?.focusOnCell(params?.areacode, params?.rowKey, params?.colKey);
                                }, 100);
                            }
                        }
                    }
                }
            }
        });
    }
    getTooltipMsg = msg => {
        if (typeof msg === 'string' && msg.indexOf('\\n') > -1) {
            msg = msg.replaceAll('\\n', '\n');
        }
        return msg;
    }
    replaceFields = (title, fields, area, props) => {
        let str = title;
        // 替换规则
        let rules = [];
        for (let f in fields) {
            let className = "toast-title-highlight";
            if(this.props?.type === 'errorCode' && fields[f].action === 'text'){
                className = '';
            }
            rules.push({ placeholder: '${' + f + '}', replacement: `<span class=${className} id="${f}" area="${area}">${fields[f].display}</span>` });
        }
        // 执行替换
        rules.forEach(rule => {
            str = str.replace(rule.placeholder, rule.replacement);
        });
        return str;
    }

    getToastType = contentMeta => {
        let res;
        contentMeta.forEach(el => {
            if (!el.fields) {
                res = el.suggestTitle ? 'suggest' : 'text';
            } else {
                for (let f in el.fields) {
                    let { action } = el.fields[f];
                    res = (action === 'pageTo') ? 'pageTo' : (action === 'locationed' ? 'locationed' : 'text');
                }
            }
        });
        return res;
    }
    /**
        * 提示的内容部分
        * contentMeta：提示内容 Array
        * title:提示标题 String
        * sign:提示标点符号 String
         */
    getContent = (contentMeta, title, sign, props) => {
        let allContent;
        let { whetherShowGroupMsg, isMinimize, json, suggestDropShow } = this.state;
        contentMeta = this.addAreaToField(contentMeta);
        // console.log(contentMeta)
        this.getFieldsNum(contentMeta);
        let toastType = this.getToastType(contentMeta);
        if (toastType === 'suggest') {//推荐
            allContent = <Fragment>
                <Fragment>
                    <span style={{ fontWeight: 'bold' }}>{title}</span><span>{sign}</span>
                    <span className='suggest'>{contentMeta[0].title}
                        <span style={{ color: '#0073E1', cursor: 'pointer', fontWeight: 400, paddingLeft: 4 }}>
                            {json['0011']} {/* 推荐 */}
                            <i className={`icon iconfont ${suggestDropShow ? 'icon-shangyitiao1' : 'icon-xiayitiao1'}`} onClick={() => this.toggleDrop()} />
                        </span>
                    </span>
                </Fragment>
                {
                    suggestDropShow && <div className='toast-suggest'>
                        <span className='suggest-title'><span className='suggest-title-txt'><i className='icon iconfont icon-a-zu171x'></i>{contentMeta[0].suggestTitle}</span> </span>
                        <ul>
                            {contentMeta[0].suggest.map((el, i) => {
                                let { title, fields, area } = el;
                                return <li key={i} dangerouslySetInnerHTML={{ __html: this.replaceFields(title, fields, area, props) }}></li>;
                            })}
                        </ul>
                    </div>
                }
            </Fragment >;
        } else if (toastType === 'locationed') {//定位 
            if (isMinimize) {
                allContent = <Fragment>
                    <div className='toast-location-minimize'>
                        {/* <NCTooltip className='toast-tooltip'
                            placement="top"
                            inverse
                            visible={this.state.showContentTip}
                            trigger="hover"
                            overlay={this.allFields[this.state.currentFieldNum - 1].display}
                            delayHide={1}
                            delayShow={1000}  > */}
                        <span className='toast-location-minimize-txt'
                            onClick={() => { this.getCurrentField(this.allFields[this.state.currentFieldNum - 1].display, this.allFields[this.state.currentFieldNum - 1].area, props); }}
                            onMouseOver={e => { this.toastTipsShow(e); }}
                            onMouseOut={() => { this.toastTipsHide(); }}>
                            {this.allFields[this.state.currentFieldNum - 1].display}
                        </span>
                        {/* </NCTooltip> */}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span className='toast-location-minimize-icon'>({this.state.currentFieldNum}/{this.allFields.length})</span>
                            <i className='icon iconfont icon-shangyitiao1' onClick={() => this.preField(props)} />
                            <i className='icon iconfont icon-xiayitiao1' onClick={() => this.nextField(props)} />
                            <i className={`icon iconfont icon-zuidahua1`} onClick={() => this.maxToast()} />
                        </div>
                    </div>
                </Fragment >;
            } else {
                allContent = <Fragment>
                    <div style={{ position: "relative" }}><span style={{ fontWeight: 'bold' }}>{title}</span> {sign} <span style={{ marginRight: 20 }}>{contentMeta[0].title}</span></div>
                    <div style={{ fontWeight: 'bold', display: whetherShowGroupMsg ? 'block' : 'none' }}>
                        {contentMeta.map((el, i) => {
                            if (i === 0) { return; }
                            let { title, fields, area } = el;
                            if (!fields) {
                                return <div>{title}</div>;
                            }
                            return <span style={{ fontWeight: 400 }} key={i} dangerouslySetInnerHTML={{ __html: this.replaceFields(title, fields, area, props) }} />;
                        })}
                    </div>
                </Fragment>;
            }
        } else {
            allContent = <Fragment>
                <span style={{ fontWeight: 'bold' }}>{title}</span>{sign}
                <span style={{ fontWeight: 400 }}>
                    {contentMeta.map((el, i) => {
                        let { title, fields, area } = el;
                        if (!fields) {
                            return <div>{title}</div>;
                        }
                        return <span key={i} dangerouslySetInnerHTML={{ __html: this.replaceFields(title, fields, area, props) }} />;
                    })}</span>
            </Fragment>;
        }
        return allContent;
    }

    toastTipsShow = e => {
        const rect = e?.currentTarget?.getBoundingClientRect();
        const width = rect?.width;
        if (width >= 239) {
            this.setState({ showContentTip: true });
        }
        e.stopPropagation();
    }
    // 隐藏tooltip
    toastTipsHide = () => {
        this.setState({ showContentTip: false });
    }

    getGroupContent = (title, sign, content, groupOperationMsg) => {
        let { groupShow, isMinimize } = this.state;
        if (!isMinimize) {
            return <Fragment>
                {title && <Fragment><span>{title}</span> {sign} </Fragment>}
                {content && <span>{content}</span>}
                {groupShow && <ul className="groupOperationMsg">
                    {groupOperationMsg.map((el, i) => {
                        return <li key={i}>{el}</li>;
                    })}
                </ul>}
            </Fragment>;
        } else {
            return null;
        }
    }

    /**
     * toast的内容部分
     * content：content参数的值  String
     * title：title参数的值  String 
     * light：弱提示的标志 Boolean
     * whetherShowGroupMsg：是否显示群组操作提示信息 Boolean
     * groupOperationMsg：群组操作提示信息 Array
     * contentMeta：提示内容 Array
      */
    showContent = (color, content, title, light, whetherShowGroupMsg, groupOperationMsg, usePunctuation, contentMeta, props) => {
        // sign 成功，错误类型 title和content用 ! 连接
        // sign 信息，警告类型 title和content用 。 连接
        let c,
            currentC,
            sign = '。';
        // usePunctuation 使用标点符号 默认true 按照UE提供的规则拼接
        if (!usePunctuation) {
            sign = '';
        } else if (color === 'danger' || color === 'success' || color === 'warning') {
            sign = '!';
        }

        if (content) {
            c = content;
            //字符串
            if (typeof c === 'string') {
                //c = content.split('\\n').join('<br/>');
                // c = c.split('"').join('');
                //c = c.split('\\r').join('<br/>');
                let cRows = c.split(/\\r|\\n/);
                let len = cRows.length;
                if (len > 1) {
                    c = cRows.map((e, index) => {
                        if (index === len - 1) {
                            return e;
                        } else {
                            return <Fragment>{e}<br /></Fragment>;
                        }
                    });
                }
            }
            currentC = groupOperationMsg ? this.getGroupContent(title, sign, content, groupOperationMsg) : (title ? <Fragment>
                <span style={{ fontWeight: 'bold' }}> {title} </span> {sign} {c}
            </Fragment> : <Fragment>{c}</Fragment>);
        } else if (contentMeta && Array.isArray(contentMeta)) {
            currentC = this.getContent(contentMeta, title, sign, props);
        } else {
            currentC = groupOperationMsg ? this.getGroupContent(title, sign, content, groupOperationMsg) : (title ? <Fragment>{title}</Fragment> : null);
        }

        if (light) {
            return currentC;
        } else {
            return (
                <div className='contentWrap'>
                    {
                        <div
                            className='toast-content'
                        // dangerouslySetInnerHTML={{ __html: currentC }}
                        >
                            {currentC}
                            {/* {whetherShowGroupMsg &&
                      groupOperationMsg &&
                      Array.isArray(groupOperationMsg) && (
                          <ul className="groupOperationMsg">
                              {groupOperationMsg.map((el, i) => {
                                  return <li key={i}>{el}</li>;
                              })}
                          </ul>
                        )} */}
                        </div>
                    }
                </div>
            );
        }
    };

    /**
     * 2个文字按钮
     * closeText:关闭消息提示按钮的文字 String
     * onClose：关闭回调 Function
     * okText:另外一个按钮的文字  String
     * onExpand：'展开'/'收起' 按钮的回调 Function
     * TextArr：按钮名字的数组 Array
     */
    expandTBtn = (okText, closeText, onClose, onExpand, TextArr) => {
        let { customBtn } = this.props;
        let { whetherShowGroupMsg } = this.state;
        return (
            <div className="expandTBtn">
                <span
                    className="closePrompt"
                    onClick={() => {
                        this.closeToast();
                        if (onClose) { onClose(); }
                    }}
                >
                    {closeText}
                </span>
                <span
                    className="showResult"
                    onClick={() => {
                        TextArr.length === 3 ? this.ToShowGroupOperationMsg() : () => {
                            this.setState({ isMinimize: true });
                        };
                        if (onExpand) { onExpand(); }
                    }}
                >
                    {okText}
                </span>
                {whetherShowGroupMsg && customBtn ? customBtn : null}
            </div>
        );
    };

    showCloseFun = (toastType, isMinimize, onClose) => {
        let res = null;
        if (!isMinimize || toastType === 'locationed') {
            res = <i className='iconfont icon-guanbi'
                onClick={() => {
                    this.closeToast();
                    if (onClose) { onClose(); }
                }}
            ></i>;
        }
        return res;
    }
    /**
     * 关闭文字按钮
     * light：是否是弱提示 Boolean
     * onClose：关闭回调 Function
     * haveExpandTBtn:.类名  String
     */
    closeIcon = (light, haveExpandTBtn, color, onClose) => {
        let { json, isMinimize } = this.state;
        let {
            groupOperation,
            customBtnBeforeClose, contentMeta, content, groupOperationMsg,
        } = this.props;
        let toastType = contentMeta && this.getToastType(contentMeta);
        let closeIcon = this.showCloseFun(toastType, isMinimize, onClose);
        if (light === false) {
            {/* 预警类型(黄色)增加”关闭”按钮 */ }
            return (
                <React.Fragment>
                    <div className="custom-btn-before-close">
                        {groupOperation && customBtnBeforeClose && <i className="before-close-btn">
                            {groupOperation && customBtnBeforeClose}
                        </i>}
                        {groupOperation && customBtnBeforeClose && !this.state.isMinimize && <i className='iconfont icon-guanbi'
                            onClick={() => {
                                this.closeToast();
                                if (onClose) { onClose(); }
                            }}></i> || closeIcon}
                    </div>
                </React.Fragment>
            );
        }
    };

    /**
     * toast左边的图标
     * color:提示框的四种类型  String
     */
    toastIcon = color => {
        let iconName = 'icon-wancheng';
        if (color === 'danger') {
            iconName = 'icon-shibai';
        } else if (color === 'warning') {
            iconName = 'icon-zhuyi1';
        } else if (color === 'info') {
            iconName = 'icon-tixing';
        } else if (color === 'custom') {
            iconName = this.props.customIcon;
        }
        let name = `toast-icon iconfont ${iconName} ${color}`;
        return (
            <i
                className={name}
                onClick={() => {
                    if (color === 'danger' && this.state.isMinimize) {
                        // 永远都不会走到这里了，所有类型鼠标进入，mouserenter事件中 isMinimize 会被设置为false
                        // console.log('图标toastIcon');
                        // this.setState({ isMinimize: false }, () => {
                        //     setTimeout(() => {
                        //         this.resetToastPosition();
                        //     });
                        // });
                    }
                }}
            />
        );
    };

    handleClick = (id, area, props) => {
        // console.log(`点击了第${id}个span`, this.allFields);
        this.focusField(id, area, props);
    };

    getDuration = (light, color, duration, miniTime) => {
        let durationVal = 2;
        if (light) { //弱提示
            durationVal = 2;
        } else {
            if (color !== 'danger') {
                if (duration && typeof duration === 'number') {
                    // 经产品经理(李聪慧)和刘源确认:color为warning/info时，允许业务自定义气泡消失时间
                    durationVal = duration;
                }
                if (durationVal === 2 && color === 'warning') {
                    durationVal = 3.8;
                }
            } else {
                durationVal = miniTime;
            }
        }
        return durationVal;
    }
    render() {
        let {
            color,
            content,
            title,
            groupOperationMsg,
            TextArr,
            onExpand,
            onClose,
            mark,
            lightClick,
            className: userClassName,
            duration,
            miniTime = 3,
            light = false, //弱提示
            usePunctuation = true, // 使用标点符号
            groupOperation,
            customBtnBeforeClose,
            contentMeta,
            props,
            global,
        } = this.props;
        let { whetherShowGroupMsg, isSlideOut, isMinimize, json, mouseenterFlag, groupShow, position } = this.state;
        let expandTBtnArg1,
            expandTBtnArg2;
        let haveExpandTBtn = 'toast-modal-noExpandBtn';
        if (TextArr && TextArr.length > 1) {
            if (TextArr.length === 2) {
                expandTBtnArg1 = TextArr[0];
                expandTBtnArg2 = TextArr[1];
                haveExpandTBtn = 'toast-modal-haveExpandBtn';
            } else if (TextArr.length === 3 && groupOperationMsg && groupOperationMsg.length > 0) {
                expandTBtnArg1 = whetherShowGroupMsg ? TextArr[1] : TextArr[0];
                expandTBtnArg2 = TextArr[2];
                haveExpandTBtn = 'toast-modal-haveExpandBtn';
            } else {
                haveExpandTBtn = 'toast-modal-noExpandBtn';
            }
        }
        if (!title && !content) {
            if (color === 'success') {
                title = json['0001'];
            } else if (color === 'info') {
                title = json['0002'];
            } else if (color === 'warning') {
                title = json['0003'];
            } else if (color === 'danger') {
                title = json['0004'];
            }
        }
        let miniClass;
        let toastType = Array.isArray(contentMeta) && this.getToastType(contentMeta);
        if (isMinimize) {
            if (toastType === 'locationed') {
                miniClass = 'customMinimize';
            } else {
                miniClass = 'minimize';
            }
        }
        let toastModalExpandBtn = haveExpandTBtn === 'toast-modal-noExpandBtn' && groupOperation && customBtnBeforeClose && (color === 'danger' || color === 'warning') ? 'toast-modal-haveExpandBtn' : '';
        let className;
        if (light) {
            let toastCon = 'toast-modal-light';
            className = `toast-modal ${toastCon} ${color}`;
        } else {
            className = `toast-modal ${miniClass}  ${color} ${haveExpandTBtn} ${userClassName} ${toastModalExpandBtn}`;
        }
        // 自动化标识
        let isAutomated = this.ncc_automated_switch === '1';
        // 动画时间
        let defaultDuration = this.getDuration(light, color, duration, miniTime);
        return (
            <div
                fieldid={getSysFieldid('tips-window')}
                className={`toast-mask-modal demo--demo ${light ? 'toast-mask-modal-light' : 'toast-mask-modal-normal'} ${isSlideOut ? (light ? 'fadeOut' : 'slideOut') : ''}`}
                data-mark={mark}
                ref={dom => {
                    this.toastWrapper = dom;
                }}
            >
                {isAutomated ? <div className={className}
                    style={{ paddingRight: light ? '' : (expandTBtnArg1 && expandTBtnArg2) ? '20px' : (toastType === 'locationed' ? (isMinimize ? '40px' : '66px') : (isMinimize ? '' : '54px')) }}
                    ref={dom => {
                        this.toast = dom;
                    }}
                    onClick={e => {
                        if (light && isFunction(lightClick)) { lightClick(); }
                        if (e.target.tagName === 'SPAN') {
                            const id = e.target.id;
                            const area = e.target?.attributes.area?.nodeValue;
                            this.handleClick(id, area, props);
                        }
                    }}
                >
                    <div className="toast-fill-mask">
                        {global ? null : <div
                            className={`toast-fill-mask-shape ${isSlideOut ? '' : 'toast-fill-mask-animation'} ${isAutomated ? 'toast-fill-mask-automated' : ''}`}
                            style={{
                                animationDuration: `${defaultDuration}s`,
                                animationPlayState: mouseenterFlag ? 'paused' : 'running',
                            }}
                        >
                        </div>}
                    </div>
                    {this.toastIcon(color)}
                    {this.showContent(color, content, title, light, whetherShowGroupMsg, groupOperationMsg, usePunctuation, contentMeta, props)}
                    {((toastType === 'locationed' && !isMinimize) || (TextArr && TextArr.length > 1 && (expandTBtnArg1 && expandTBtnArg2 && groupShow))) && <i className={`icon iconfont icon-zuixiaohua`} onClick={() => this.miniToast()} />}
                    {(TextArr && TextArr.length > 1 && (expandTBtnArg1 && expandTBtnArg2)) && !groupShow && !isMinimize && <i className={`icon iconfont icon-zuidahua1`} onClick={() => this.maxToast()} />}
                    {this.closeIcon(light, haveExpandTBtn, color, onClose)}
                </div>
                    :
                    <NCDnd cancel='.toast-content'
                        bounds='body'
                        position={position}
                        onStart={e => {
                            e.preventDefault();
                            document.querySelectorAll('#mainiframe').forEach(frame => {
                                frame.style.pointerEvents = 'none';
                            });
                            this.toast.style.transition = '';
                        }}
                        onDrag={(e, data) => {
                            this.setState({
                                position: { x: data.x, y: data.y },
                                mouseenterFlag: true,
                                moveY: data.y,
                            });
                        }}
                        onStop={(e, data) => {
                            // console.log(data)
                            document.querySelectorAll('#mainiframe').forEach(frame => {
                                frame.style.pointerEvents = 'all';
                            });
                            this.toast.style.transition = '0.2s';

                            if (e.target.classList.contains('icon-zuidahua1') || e.target.classList.contains('icon-zuixiaohua')) {
                                return;
                            }
                            this.toastMoved = true;
                            if (this.state.isMinimize || userClassName === 'systemnotifi' || this.props.global) {
                                this.setState({
                                    position: { x: 0, y: data.y },
                                    mouseenterFlag: false,
                                    moveY: data.y,
                                });
                                this.toast.style.setProperty('right', '1px');
                            }
                        }}
                    >
                        <div className={className}
                            style={{ paddingRight: light ? '' : (expandTBtnArg1 && expandTBtnArg2) ? '20px' : (toastType === 'locationed' ? (isMinimize ? '40px' : '66px') : (isMinimize ? '' : '54px')) }}
                            ref={dom => {
                                this.toast = dom;
                            }}
                            onClick={e => {
                                if (light && isFunction(lightClick)) { lightClick(); }
                                if (e.target.tagName === 'SPAN') {
                                    const id = e.target.id;
                                    const area = e.target?.attributes.area?.nodeValue;
                                    this.handleClick(id, area, props);
                                }
                            }}
                        >
                            <div className="toast-fill-mask">
                                {global ? null : <div
                                    className={`toast-fill-mask-shape ${isSlideOut ? '' : 'toast-fill-mask-animation'} ${isAutomated ? 'toast-fill-mask-automated' : ''}`}
                                    style={{
                                        animationDuration: `${defaultDuration}s`,
                                        animationPlayState: mouseenterFlag ? 'paused' : 'running',
                                    }}
                                >
                                </div>}
                            </div>
                            {this.toastIcon(color)}
                            {this.showContent(color, content, title, light, whetherShowGroupMsg, groupOperationMsg, usePunctuation, contentMeta, props)}
                            {((toastType === 'locationed' && !isMinimize) || (TextArr && TextArr.length > 1 && (expandTBtnArg1 && expandTBtnArg2 && groupShow))) && <i className={`icon iconfont icon-zuixiaohua`} onClick={() => this.miniToast()} />}
                            {(TextArr && TextArr.length > 1 && (expandTBtnArg1 && expandTBtnArg2)) && !groupShow && !isMinimize && <i className={`icon iconfont icon-zuidahua1`} onClick={() => this.maxToast()} />}
                            {this.closeIcon(light, haveExpandTBtn, color, onClose)}
                        </div>
                    </NCDnd >}
            </div >
        );
    }
}
